var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-link",
    {
      staticClass: "sidebar-link",
      class: { "is-active": _vm.active },
      attrs: {
        to: _vm.to,
        title: _vm.collapsed ? _vm.label : null,
        "aria-current": _vm.active ? "page" : null,
      },
      nativeOn: {
        click: function ($event) {
          return _vm.$emit("select")
        },
      },
    },
    [
      _vm.icon
        ? _c("lucide-icon", {
            staticClass: "sidebar-link__icon",
            attrs: { icon: _vm.icon, size: 18, "aria-hidden": "true" },
          })
        : _vm.fallbackIcon
        ? _c("svg-icon", {
            attrs: {
              "icon-class": _vm.fallbackIcon,
              "class-name": "sidebar-link__icon",
            },
          })
        : _vm._e(),
      _c("span", { staticClass: "sidebar-link__label" }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
      _vm.active ? _c("span", { staticClass: "sidebar-link__dot" }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }